module.exports = __webpack_public_path__ + "img/banner_1024x2.7b254eea.jpg";